export default __webpack_public_path__ + "2c40628299b93c6a31b10b7ba83b376c.png";